// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Id from "../../../../node_modules/rescript/lib/es6/belt_Id.js";
import * as Belt_Set from "../../../../node_modules/rescript/lib/es6/belt_Set.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Tap$Showside from "../utils/Tap.bs.js";
import * as UseSafeTimeout from "../../../../node_modules/@makerinc/use-safe-timeout/lib/es6_global/src/UseSafeTimeout.bs.js";
import * as Product$Showside from "../types/Product.bs.js";
import * as Previous$Showside from "../utils/Previous.bs.js";
import * as Slider_Lazy$Showside from "../utils/Slider_Lazy.bs.js";
import * as QuickViewTabs$Showside from "./QuickViewTabs.bs.js";
import * as ReactDOMUtils$Showside from "../utils/ReactDOMUtils.bs.js";
import * as ResizeObserver$Showside from "../utils/ResizeObserver.bs.js";
import * as ProductListItem$Showside from "./ProductListItem.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as UseDisplayVariantBy$Showside from "../hook/UseDisplayVariantBy.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as QuickViewOverlayButton$Showside from "./QuickViewOverlayButton.bs.js";
import * as StickyHeaderOffsetProvider$Showside from "../context/StickyHeaderOffsetProvider.bs.js";
var lastVisible = {
  contents: undefined
};
function cmp(a, b) {
  if (a.id === b.id) {
    return 0;
  } else {
    return 1;
  }
}
var ProductCompare = Belt_Id.MakeComparable({
  cmp: cmp
});
function QuickViewProductCarousel(Props) {
  var enabled = Props.enabled;
  var visibleOpt = Props.visible;
  var media = Props.media;
  var pins = Props.pins;
  var showViewAllButton = Props.showViewAllButton;
  var flippedExpanded = Props.flippedExpanded;
  var visualMediaHeight = Props.visualMediaHeight;
  var slideToProductRef = Props.slideToProductRef;
  var drawerOffsetControllerRef = Props.drawerOffsetControllerRef;
  var children = Props.children;
  var progressSpeed = Props.progressSpeed;
  var setProgressRef = Props.setProgressRef;
  var onProductHighlight = Props.onProductHighlight;
  var onProductClick = Props.onProductClick;
  var onClickViewProducts = Props.onClickViewProducts;
  var onChangeVisibility = Props.onChangeVisibility;
  var visible = visibleOpt !== undefined ? visibleOpt : /* AutoCollapse */0;
  var match = EntrypointContext$Showside.use(undefined);
  var trackEvent = match.trackEvent;
  var siteHeaderHeight = StickyHeaderOffsetProvider$Showside.useLenient(undefined);
  var visualMediaHeight$1 = visualMediaHeight + siteHeaderHeight | 0;
  var match$1 = React.useState(function () {
    return Belt_Option.getWithDefault(lastVisible.contents, visible);
  });
  var setVisible = match$1[1];
  var visible$1 = match$1[0];
  var match$2 = React.useState(function () {});
  var setActiveProduct = match$2[1];
  var activeProduct = match$2[0];
  var products = Belt_Set.toArray(Belt_Set.fromArray(Belt_Array.map(pins, function (pin) {
    return pin.product;
  }), ProductCompare));
  var carouselRef = React.useRef(null);
  var carouselBounds = ResizeObserver$Showside.useResizeObserver(undefined, carouselRef);
  var carouselHeight = Belt_Option.mapWithDefault(carouselBounds, 104, function (bounds) {
    return bounds.height;
  });
  var match$3 = ViewportContext$Showside.use(undefined);
  var isMobile = match$3.isMobile;
  var displayVariantBy = UseDisplayVariantBy$Showside.useDisplayVariantBy(undefined);
  var match$4 = ConfigurationProvider$Showside.use(undefined);
  var match$5 = match$4.config.settings;
  var openLinkInNewTab = match$5.openLinkInNewTab;
  var hideOutOfStock = match$5.hideOutOfStock;
  var productCardShape = match$5.productCardShape;
  var productCardFitToContainer = match$5.productCardFitToContainer;
  var match$6 = UseSafeTimeout.useSafeTimeout(undefined, undefined);
  var clearCollapseTimeout = match$6.clearTimeout;
  var setCollapseTimeout = match$6.setTimeout;
  var match$7 = UseSafeTimeout.useSafeTimeout(undefined, undefined);
  var clearExpandTimeout = match$7.clearTimeout;
  var setExpandTimeout = match$7.setTimeout;
  var willAutoCollapse = Previous$Showside.usePreviousDistinct(visible$1) === /* AutoCollapse */0;
  lastVisible.contents = visible$1;
  var slideToIndexRef = React.useRef(function (param) {});
  var setActiveProduct$1 = function (setter) {
    Curry._1(setActiveProduct, function (prevProduct) {
      var nextProduct = Curry._1(setter, prevProduct);
      Curry._1(onProductHighlight, nextProduct);
      return nextProduct;
    });
  };
  var showCarousel = visible$1 === /* Expanded */1 && media.pins.length !== 0;
  React.useEffect(function () {
    if (!willAutoCollapse) {
      Curry._1(onChangeVisibility, showCarousel);
    }
  }, [showCarousel]);
  React.useEffect(function () {
    return function (param) {
      lastVisible.contents = undefined;
    };
  }, []);
  React.useEffect(function () {
    if (flippedExpanded && showCarousel) {
      Curry._1(drawerOffsetControllerRef.current, carouselHeight);
    } else {
      Curry._1(drawerOffsetControllerRef.current, 0);
    }
  }, [showCarousel, flippedExpanded, carouselHeight]);
  React.useEffect(function () {
    if (!showCarousel) {
      Curry._1(onProductHighlight, undefined);
    }
  }, [showCarousel, Belt_Option.map(activeProduct, function (p) {
    return p.id;
  })]);
  React.useEffect(function () {
    var exit = 0;
    if (willAutoCollapse || visible$1 === 0) {
      exit = 1;
    }
    if (exit === 1) {
      Curry._1(clearCollapseTimeout, undefined);
      Curry._1(clearExpandTimeout, undefined);
      setExpandTimeout(function (param) {
        Curry._1(setVisible, function (param) {
          return /* Expanded */1;
        });
      }, 500);
      setCollapseTimeout(function (param) {
        Curry._1(setVisible, function (param) {
          return /* Collapsed */2;
        });
      }, 2500);
    }
  }, [visible$1]);
  var interceptAutoCollapse = function (param) {
    Curry._1(clearCollapseTimeout, undefined);
    Curry._1(clearExpandTimeout, undefined);
    Curry._1(onChangeVisibility, true);
    Curry._1(setVisible, function (param) {
      return /* Expanded */1;
    });
  };
  var getProductIndex = function (product) {
    return Belt_Array.getIndexBy(products, function (p) {
      return p.id === product.id;
    });
  };
  var highlightProductAtIndex = function (i) {
    setActiveProduct$1(function (param) {
      return Belt_Array.get(products, i);
    });
    Curry._1(slideToIndexRef.current, i);
  };
  var stopTouchPropagation = function (e) {
    e.stopPropagation();
  };
  var handleTouch = function (e) {
    e.stopPropagation();
    interceptAutoCollapse(undefined);
  };
  var handleToggleCarousel = function (e) {
    Curry._1(clearCollapseTimeout, undefined);
    Curry._1(clearExpandTimeout, undefined);
    Curry._1(setVisible, function (visible) {
      if (visible === /* Expanded */1) {
        return /* Collapsed */2;
      } else {
        highlightProductAtIndex(Belt_Option.getWithDefault(Belt_Option.flatMap(activeProduct, getProductIndex), 0));
        return /* Expanded */1;
      }
    });
  };
  var handleProductClick = function (product, variant) {
    Curry.app(trackEvent, ["Clicked In-Media Product Card", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
    Curry._2(onProductClick, product, variant);
  };
  React.useEffect(function () {
    Curry._1(slideToIndexRef.current, 0);
    slideToProductRef.current = function (product) {
      Tap$Showside.tap(Belt_Option.forEach(getProductIndex(product), highlightProductAtIndex), interceptAutoCollapse);
    };
  }, [Belt_Array.map(products, function (p) {
    return p.id;
  }).join(",")]);
  var items = Belt_Array.mapWithIndex(products, function (i, product) {
    var variant = Product$Showside.getInitialDisplayVariant(hideOutOfStock, Belt_Option.flatMap(Belt_Array.get(pins, i), function (pin) {
      return pin.variantId;
    }), displayVariantBy, product);
    return React.createElement("div", {
      className: CSS$Showside.prefix(Cn.make(["p-3 leading-0 h-full", flippedExpanded ? "" : "pt-0", i === 0 ? "" : "-ml-3"]))
    }, React.createElement(ProductListItem$Showside.make, {
      product: product,
      variant: variant,
      shape: productCardShape,
      imageFitStrategy: productCardFitToContainer ? /* Contain */2 : /* Cover */1,
      titleLineClamp: 2,
      flushed: false,
      padding: false,
      hideOutOfStock: hideOutOfStock,
      height: "full",
      imageSize: [72, 72],
      onClick: handleProductClick,
      className: CSS$Showside.prefix("bg-main rounded-custom p-2 drop-shadow-sm filter"),
      displayVariantBy: displayVariantBy,
      key: String(i)
    }));
  });
  var handleSlideChange = function ($$event) {
    Tap$Showside.tap(Belt_Option.forEach($$event.activeIndex, highlightProductAtIndex), interceptAutoCollapse);
  };
  var className = CSS$Showside.prefix(Cn.make(["w-full", "transition-opacity duration-300", showCarousel ? "opacity-100 pointer-events-auto" : "opacity-0"]));
  var slider = React.createElement("div", {
    className: className,
    onTouchEnd: handleTouch,
    onTouchMove: handleTouch,
    onTouchStart: handleTouch
  }, React.createElement(Slider_Lazy$Showside.make, {
    items: items,
    slidesPerView: /* Float */{
      _0: products.length === 1 ? 1 : 1.3
    },
    freeModeSticky: true,
    centeredSlides: true,
    centeredSlidesBounds: true,
    slideToIndexRef: slideToIndexRef,
    enableNavigation: false,
    className: Cn.make(["swiper-shared-height", CSS$Showside.prefix("w-full")]),
    onSlideChange: handleSlideChange
  }));
  var renderProgressBar = function (param) {
    if (setProgressRef === undefined) {
      return null;
    }
    var tmp = {
      className: CSS$Showside.prefix("bg-accent h-full absolute left-0 top-0"),
      mediaId: media.id,
      autoplay: true
    };
    if (progressSpeed !== undefined) {
      tmp.progressSpeed = progressSpeed;
    }
    if (setProgressRef !== undefined) {
      tmp.setProgressRef = Caml_option.valFromOption(setProgressRef);
    }
    return React.createElement("div", {
      className: CSS$Showside.prefix("h-px w-full bg-transparent absolute left-0 -top-px")
    }, React.createElement(QuickViewTabs$Showside.ProgressBar.make, tmp));
  };
  var renderCarousel = function (param) {
    var content = React.createElement("div", {
      ref: ReactDOMUtils$Showside.Ref.domRef(carouselRef),
      className: CSS$Showside.prefix(Cn.make(["absolute top-0 left-0 w-full flex flex-col items-center justify-center", "pointer-events-none", "transition-all duration-300", "transform", showCarousel && !flippedExpanded ? "-translate-y-full" : "translate-y-0", enabled ? "opacity-100" : "opacity-0"])),
      onTouchEnd: stopTouchPropagation,
      onTouchMove: stopTouchPropagation
    }, flippedExpanded ? renderProgressBar(undefined) : null, React.createElement("div", {
      className: CSS$Showside.prefix(Cn.make(["flex", "absolute top-0 w-full", "transform -translate-y-full", "transition-all duration-300"]))
    }, React.createElement(QuickViewOverlayButton$Showside.make, {
      kind: showCarousel ? /* Close */0 : /* ViewProducts */2,
      at: /* MediaBox */{
        _0: media
      },
      size: /* Large */2,
      margin: "0 0 6px 6px",
      openLinkInNewTab: openLinkInNewTab,
      canCollapse: false,
      isMobile: isMobile,
      containerClassName: CSS$Showside.prefix("flex items-end"),
      productsInMedia: products,
      onClick: handleToggleCarousel
    }), children), products.length !== 0 && isMobile ? slider : null);
    if (flippedExpanded) {
      return React.createElement("div", {
        className: CSS$Showside.prefix("fixed w-full"),
        style: {
          top: CSS$Showside.intToPx(visualMediaHeight$1)
        }
      }, content);
    } else {
      return content;
    }
  };
  var renderFallback = function (param) {
    var kind;
    if (media.description !== undefined) {
      kind = /* ViewDetails */1;
    } else {
      var link = media.link;
      kind = link !== undefined ? (/* LearnMore */{
        _0: link
      }) : /* Hidden */5;
    }
    var onClick = kind === 1 ? onClickViewProducts : function (param) {};
    return React.createElement("div", {
      className: CSS$Showside.prefix(Cn.make(["flex", "absolute top-0 w-full", "transform -translate-y-full", "pointer-events-none"])),
      onTouchEnd: stopTouchPropagation,
      onTouchMove: stopTouchPropagation
    }, React.createElement(QuickViewOverlayButton$Showside.make, {
      kind: kind,
      at: /* MediaBox */{
        _0: media
      },
      size: /* Large */2,
      margin: "0 0 6px 6px",
      openLinkInNewTab: openLinkInNewTab,
      style: showViewAllButton ? {
        opacity: "1"
      } : {
        opacity: "0",
        pointerEvents: "none"
      },
      canCollapse: false,
      isMobile: isMobile,
      containerClassName: CSS$Showside.prefix("flex items-end"),
      productsInMedia: products,
      onClick: onClick
    }), flippedExpanded ? renderProgressBar(undefined) : null, children);
  };
  var content = products.length !== 0 ? renderCarousel(undefined) : renderFallback(undefined);
  return React.createElement(React.Fragment, undefined, content, flippedExpanded ? null : renderProgressBar(undefined));
}
QuickViewProductCarousel.displayName = "QuickViewProductCarousel";
var introDelay = 500;
var outroDelay = 2500;
var make = QuickViewProductCarousel;
export { introDelay, outroDelay, lastVisible, ProductCompare, make };
/* ProductCompare Not a pure module */